var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5007 7C10.5007 5.54395 9.61064 4.29707 8.34736 3.77002L8.01103 4.57803C8.9585 4.97383 9.625 5.90898 9.625 7C9.625 8.09307 8.9585 9.02617 8.00898 9.42197L8.34531 10.23C9.61064 9.70293 10.5007 8.45605 10.5007 7ZM8.74932 7C8.74932 6.27197 8.3043 5.64854 7.67266 5.38604L7.33633 6.19404C7.65215 6.32529 7.87363 6.63701 7.87363 7.00205C7.87363 7.36504 7.65215 7.67676 7.33633 7.81006L7.67266 8.61807C8.3043 8.35146 8.74932 7.72803 8.74932 7ZM9.02002 2.154L8.68164 2.96201C10.2628 3.62031 11.3743 5.17891 11.3743 7C11.3743 8.81904 10.2628 10.3797 8.68164 11.038L9.01797 11.846C10.917 11.0544 12.25 9.18408 12.25 7C12.25 4.81592 10.917 2.94561 9.02002 2.154ZM1.75 4.81182V9.18613H3.49932L6.56318 12.25V1.75L3.49932 4.81182H1.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIcon);
export default __webpack_public_path__ + "static/media/speaker_icon.11204374a7df80113e12a308f2715646.svg";
export { ForwardRef as ReactComponent };